
export default {
  computed: {
    btnText() {
      return this.$device.isMobile ? this.$t('commons.close') : this.$t('commons.esc')
    },
  },
}
